import React, { useState } from 'react'
import { MdOutlineSubdirectoryArrowLeft } from 'react-icons/md'
import PDFIcon from '../../assets/pdf.png'
import { NavLink } from 'react-router-dom'
import ImageView from 'components/ImageView'
import { searchValueAtom } from 'pages/MainDashboard'
import { useAtomValue } from 'jotai'
import Highlighter from 'react-highlight-words'
import { ConvertLinksToClickable } from 'components/Responses/ClickableResponses'

export const GeneralSnapIntel = ({ responses, questions }) => {
    const [collapse, setCollapse] = useState(true)
    const [selectedImage, setSelectedImage] = useState()
    const searchValue = useAtomValue(searchValueAtom)

    return (
        <div className="w-full shadow-md rounded-md">
            {selectedImage != null && (
                <ImageView image={selectedImage} onClose={() => setSelectedImage(null)} />
            )}
            <div className="w-full bg-main py-2 px-2 flex justify-between items-center rounded-t-md">
                <p className="font-semibold text-white">General SnapIntel Conversation</p>
            </div>
            {questions?.length > 0 ? (
                <div className="w-full h-fit max-h-[350px] overflow-y-auto px-5 flex flex-col gap-3 py-5 bg-gray-200 rounded-b-md">
                    {questions.map((question) => (
                        <div key={question.id} className="flex w-full flex-col gap-3">
                            <div className="flex w-full items-center gap-2 px-2">
                                <div className="text-xs bg-main bg-opacity-30 p-2 rounded-r-md rounded-tl-md shadow-sm">
                                    <Highlighter
                                        searchWords={[searchValue]}
                                        autoEscape={true}
                                        textToHighlight={question.question}
                                        highlightClassName="bg-yellow-200"
                                    />
                                </div>
                            </div>
                            <div
                                onClick={() => setCollapse(!collapse)}
                                className="cursor-pointer pl-5 flex gap-2 items-center text-xs hover:text-[14px]"
                            >
                                <span
                                    className="rotate-90 text-md -mt-2 cursor-pointer"
                                    onClick={() => setCollapse(!collapse)}
                                >
                                    <MdOutlineSubdirectoryArrowLeft />
                                </span>
                                <span>{collapse ? 'Hide' : 'Show'} Responses</span>
                            </div>
                            {collapse && (
                                <React.Fragment>
                                    {responses
                                        .filter((response) => question.id === response.question_id)
                                        .map((response, index) => (
                                            <div
                                                key={index}
                                                className="flex w-full items-center justify-end gap-2 px-2"
                                            >
                                                <div className="">
                                                    <div className="text-xs py-1 font-semibold text-end">
                                                        <Highlighter
                                                            searchWords={[searchValue]}
                                                            autoEscape={true}
                                                            textToHighlight={response.user.fullname}
                                                            highlightClassName="bg-yellow-200"
                                                        />
                                                    </div>
                                                    <div className="text-xs w-fit text-left bg-white bg-opacity-30 p-2 rounded-l-md rounded-tr-md shadow-sm justify-end gap-2 flex flex-col items-end">
                                                        <div key={index}>
                                                            <p className="break-all whitespace-break-spaces">
                                                                <ConvertLinksToClickable
                                                                    text={response?.answer}
                                                                />
                                                            </p>
                                                        </div>
                                                        {response.attachments &&
                                                            response.attachments?.length > 0 && (
                                                                <React.Fragment>
                                                                    {response.attachments.map(
                                                                        (attachment) => (
                                                                            <div
                                                                                className="flex items-end justify-end"
                                                                                key={attachment.id}
                                                                            >
                                                                                {attachment.type ===
                                                                                'image' ? (
                                                                                    <img
                                                                                        src={
                                                                                            attachment.filename
                                                                                        }
                                                                                        alt="Attachment"
                                                                                        className="h-[150px] cursor-pointer hover:scale-105 transition-all duration-300"
                                                                                        onClick={() =>
                                                                                            setSelectedImage(
                                                                                                attachment.filename
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                ) : attachment.type ===
                                                                                  'file' ? (
                                                                                    <NavLink
                                                                                        to={
                                                                                            attachment.filename
                                                                                        }
                                                                                        target="__blank"
                                                                                        className="transition-all duration-300 flex gap-4 h-fit items-center bg-[#c6c6c6] px-4 py-2 rounded-lg shadow-inner hover:bg-[#9a9a9a]"
                                                                                    >
                                                                                        <img
                                                                                            className="w-8"
                                                                                            src={
                                                                                                PDFIcon
                                                                                            }
                                                                                            alt="TEXT_FILE"
                                                                                        />
                                                                                        <p className="text-left text-xs break-all truncate-multiline-2">
                                                                                            <Highlighter
                                                                                                searchWords={[
                                                                                                    searchValue,
                                                                                                ]}
                                                                                                autoEscape={
                                                                                                    true
                                                                                                }
                                                                                                textToHighlight={
                                                                                                    attachment.filename
                                                                                                }
                                                                                                highlightClassName="bg-yellow-200"
                                                                                            />
                                                                                        </p>
                                                                                    </NavLink>
                                                                                ) : null}
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </React.Fragment>
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <div className="min-h-[300px] text-2xl text-gray-400 w-full flex justify-center items-center font-semibold">
                    Select a question
                </div>
            )}
        </div>
    )
}
